// Dependencias generales
import React from "react";
import { useEffect, useState } from 'react';
import RuleForm from '../../../components/Rules/RuleForm'
import ReactGA from "react-ga4";
import '../../../css/rules.css'

import imgNoResultsDark from '../../../img/dark-theme/empty-state.svg'

//URLs		
const endpointHelias = "https://9m4y8iz04h.execute-api.eu-west-3.amazonaws.com/prod"
const postListInstallationRules = endpointHelias+'/Helias/V0/Rules/postListInstallationRules'
const putInstallationRules = endpointHelias+'/Helias/V0/Rules/putInstallationRules'
const lastDashboardDataRequestURL = endpointHelias+'/Helias/V0/General/lastDashboardData'
const lastSmartDevicesStatusRequestURL = endpointHelias+'/Helias/V0/General/lastSmartDevicesStatus'
const postListInstallationSharedUsersInstallers = endpointHelias+"/Helias/V0/Configuration/postListInstallationSharedUsersInstallers"

var initialConfigCommonJS = require("../../../js/initialConfigCommon.js")
var generalCommonJS = require("../../../js/generalCommon.js")
var dashboardCommonJS = require("../../../js/dashboardCommon.js")
var rulesCommonJS = require("../../../js/rulesCommon.js")

var objDatosDashboard = []
var objDatosDispositivos = []

var numeroReglasManuales = 0
var numeroReglasInstaladores = 0

// Función del router
const RulesList = (params) => {    

    const [objListadoReglas, setObjListadoReglas] = useState([])    

    useEffect(() => {    
      
      console.log("Componente listado reglas cargado correctamente.")
      
      if(dashboardCommonJS.comprobarPropiedadInstalacion() === false){
        console.log("No soy propietario")   
        document.getElementById("botonNuevaRegla").disabled = true
        //cargarIDTelegramUsuarioCompartido()

        //Si reactivo telegram quitar estas 3 lineas
        localStorage.setItem("telegramAccount", "")
        localStorage.setItem("telegramInstallationID", localStorage.getItem("installationId"))
        document.getElementById("botonNuevaRegla").disabled = false
      }      
      else{
        //initialConfigCommonJS.comprobarEstadoRegistroMensajeria()
      }
      
      cargarReglas()      
      
      if((localStorage.getItem("lastDashboardData") === null) && (Object.keys(objDatosDashboard).length === 0)){cargarDashboard()}
      else{objDatosDashboard = JSON.parse(localStorage.getItem("lastDashboardData"))}

      if((localStorage.getItem("lastSmartDevicesStatus") === null) && (objDatosDispositivos.length === 0)){cargarDispositivosInteligentes()}
      else{objDatosDispositivos = JSON.parse(localStorage.getItem("lastSmartDevicesStatus"))}
      
      if(params.abrirNuevaRegla === "true"){ //Si es usuario NOVATO le abro directamente la creación de nueva regla.
        procesarRegla(reglaNueva, "Nueva")
      }  

    },[params.update]);

    var reglaNueva = { 
      "Rule":{
        "ruleOwnerAccountID": localStorage.getItem("accountID"),                
        "ruleOwnerInstallationID": localStorage.getItem("installationId"),
        "isInstaller": "false",
        "installationName": localStorage.getItem("installationName").split("*")[1],
        "userName": generalCommonJS.obtenerNombreCompletoUsuario(),
        "userEmail": generalCommonJS.obtenerEmailUsuario(),
        "userTelegram": "",
        "name":"",
        "actions":[{          
          "actionId": "1",
          "action": ""
        }],
        "conditions":[{
          "conditionalOperator":"",
          "comparator":"",
          "conditionId":"1",
          "atribute":"",
          "atributeValue":""
        }],
        "enabled":""
      },
      "INSTALLATION_ID": localStorage.getItem("installationId"),
      "RULE_ID":""
    }
  
    function cargarUsuariosCompartidos(){
    
      var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
      var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")        

      //Petición de datos para el paso actual
      var jsonPeticion = {
        "accountID": localStorage.getItem("accountID"),
        "installationID": localStorage.getItem("installationId"),
       }

      // Guardo la información  
      var xhttp = new XMLHttpRequest();  
        xhttp.open("POST", postListInstallationSharedUsersInstallers, true);        
        xhttp.setRequestHeader('Content-Type', "application/json");
        xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
        var data = JSON.stringify(jsonPeticion);
        xhttp.onreadystatechange = function() {
          if (this.readyState === 4 && this.status === 200) {
            var jsonRespuesta = JSON.parse(this.responseText)
    
            if(jsonRespuesta.statusCode === "403"){                   
              initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
            }
            else{          
              //Si recibo datos ya configurados lo cargo  

              if(typeof jsonRespuesta.body !== 'undefined'){    
                
                var usuariosCompartidos = ""

                for(var x=0; x<jsonRespuesta.body.Owner.length; x++){
                  if(jsonRespuesta.body.Owner[x].UserEmail !== ""){
                    usuariosCompartidos = usuariosCompartidos + jsonRespuesta.body.Owner[x].UserEmail + "#"
                  }
                }

                for(x=0; x<jsonRespuesta.body.Users.length; x++){
                  if(jsonRespuesta.body.Users[x].UserEmail !== ""){
                    usuariosCompartidos = usuariosCompartidos + jsonRespuesta.body.Users[x].UserEmail + "#"
                  }
                }

                for(x=0; x<jsonRespuesta.body.Installers.length; x++){
                  if(jsonRespuesta.body.Installers[x].InstallationEmail !== ""){
                    usuariosCompartidos = usuariosCompartidos + jsonRespuesta.body.Installers[x].InstallationEmail + "#"
                  }
                }

                usuariosCompartidos = usuariosCompartidos + "EOL"
                usuariosCompartidos = usuariosCompartidos.replaceAll ("#EOL", "")

                localStorage.setItem("sharedUsers", usuariosCompartidos)
                
              }                  

              document.getElementById("loaderGeneralAplicacion").className = "loader hidden"

              //Si no hay datos configurados entonces no hago nada  
              console.log("Listado de reglas cargado correctamente.")
            }
          }
    
          if (this.readyState === 4 && this.status !== 200) {      
            initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)          
          }
        }
        xhttp.send(data);     

    }

    function cargarReglas(modo){
    
      var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
      var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")        

      //Petición de datos para el paso actual
      var jsonPeticion = {"accountID": localStorage.getItem("accountID"), "installationID": localStorage.getItem("installationId") }

      try{
        if( modo !== "silencioso" ){
          document.getElementById("loaderGeneralAplicacion").className = "loader"
        }
      }
      catch(error){console.log(error)}

      // Guardo la información  
      var xhttp = new XMLHttpRequest();  
        xhttp.open("POST", postListInstallationRules, true);        
        xhttp.setRequestHeader('Content-Type', "application/json");
        xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
        var data = JSON.stringify(jsonPeticion);
        xhttp.onreadystatechange = function() {
          if (this.readyState === 4 && this.status === 200) {
            var jsonRespuesta = JSON.parse(this.responseText)
    
            if(jsonRespuesta.statusCode === "403"){                   
              initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
            }
            else{          
              //Si recibo datos ya configurados lo cargo  

              if(typeof jsonRespuesta.body !== 'undefined'){  
                
                cargarUsuariosCompartidos()
                
                setObjListadoReglas(jsonRespuesta.body)       

                numeroReglasManuales=0
                numeroReglasInstaladores=0

                for(var x=0; x<jsonRespuesta.body.length; x++){

                  if(jsonRespuesta.body[x].Rule.name.includes("AUTO")){ 
                    // No hago nada con las reglas automáticas
                  }
                  else if(jsonRespuesta.body[x].Rule.isInstaller === "true") {
                    numeroReglasInstaladores++
                  }
                  else{ numeroReglasManuales++ }

                }

                if(localStorage.getItem("ruleDirectLink"+localStorage.getItem("installationId")) !== null){                      

                  var directLinkRule = ""

                  for(var n=0; n < jsonRespuesta.body.length;n++){
                    if(parseInt(jsonRespuesta.body[n].RULE_ID) ===  parseInt(localStorage.getItem("ruleDirectLink"+localStorage.getItem("installationId")))){                                                
                        directLinkRule = jsonRespuesta.body[n]
                        procesarRegla(jsonRespuesta.body[n], "Editar")
                        localStorage.removeItem("ruleDirectLink"+localStorage.getItem("installationId")) 
                      break
                    }
                  }

                  if(directLinkRule === ""){
                    initialConfigCommonJS.mostrarMensajeInformativo("Esa regla ya no existe.","info")               
                  }

                }

                if(numeroReglasManuales>0){
                  document.getElementById("h1ListadoReglas").innerHTML = numeroReglasManuales + " Reglas"
                }
                else{
                  document.getElementById("h1ListadoReglas").innerHTML = "Reglas"
                }

              }                  

              //Si no hay datos configurados entonces no hago nada  
              console.log("Listado de reglas cargado correctamente.")
            }
          }
    
          if (this.readyState === 4 && this.status !== 200) {      
            initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)          
          }
        }
        xhttp.send(data);     

    }

    function cargarDashboard(){
          
      var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
      var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")        
    
      document.getElementById("loaderGeneralAplicacion").className = "loader"
    
      //Petición de datos para el paso actual
      var jsonPeticion = {
        "accountID": localStorage.getItem("accountID"),
        "installationID": localStorage.getItem("installationId") 
      }
    
      // Guardo la información  
      var xhttp = new XMLHttpRequest();  
        xhttp.open("POST", lastDashboardDataRequestURL, true);        
        xhttp.setRequestHeader('Content-Type', "application/json");
        xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
        var data = JSON.stringify(jsonPeticion);
        xhttp.onreadystatechange = function() {
          if (this.readyState === 4 && this.status === 200) {
            var jsonRespuesta = JSON.parse(this.responseText)
      
            if(jsonRespuesta.statusCode === "403"){                   
              initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
            }
            else{          
              //Si recibo datos ya configurados lo cargo  
    
              if(typeof jsonRespuesta.body !== 'undefined'){                  
                console.log(jsonRespuesta)                
                objDatosDashboard = jsonRespuesta.body   
                localStorage.setItem("lastDashboardData", JSON.stringify(jsonRespuesta.body))                     
              }  
    
              //Si no hay datos configurados entonces no hago nada  
              console.log("Datos del dashboard cargados correctamente.")
              document.getElementById("loaderGeneralAplicacion").className = "loader hidden"
                  
            }
          }
      
          if (this.readyState === 4 && this.status !== 200) {      
            initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)          
          }
        }
        xhttp.send(data);     
      
    }
    
    function cargarDispositivosInteligentes(){
    
      var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
      var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")        
    
      document.getElementById("loaderGeneralAplicacion").className = "loader"

      var datosStripe = {}                      
      if( (localStorage.getItem("stripeData") !== null) && (Object.keys(JSON.parse(localStorage.getItem("stripeData")).length > 0)) ){
        datosStripe = JSON.parse(localStorage.getItem("stripeData"))        
      } 
      
      var idPlan = ""    
      try{ idPlan = datosStripe.priceId }
      catch(error){console.log(error)}
    
      //Petición de datos para el paso actual    
      var jsonPeticion = {"accountID": localStorage.getItem("accountID"), "installationID": localStorage.getItem("installationId"), "planId": idPlan }
    
      // Guardo la información  
      var xhttp = new XMLHttpRequest();  
        xhttp.open("POST", lastSmartDevicesStatusRequestURL, true);        
        xhttp.setRequestHeader('Content-Type', "application/json");
        xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
        var data = JSON.stringify(jsonPeticion);
        xhttp.onreadystatechange = function() {
          if (this.readyState === 4 && this.status === 200) {
            var jsonRespuesta = JSON.parse(this.responseText)
    
            if(jsonRespuesta.statusCode === "403"){                   
              initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
              document.getElementById("loaderGeneralAplicacion").className = "loader hidden"
            }
            else{          
              //Si recibo datos ya configurados lo cargo  
        
              if(typeof jsonRespuesta.body !== 'undefined'){
                console.log(jsonRespuesta)              
                objDatosDispositivos = jsonRespuesta.body  
                localStorage.setItem("lastSmartDevicesStatus", JSON.stringify(jsonRespuesta.body))          
              }              
    
              console.log("Dispositivos inteligentes cargados correctamente.")
              document.getElementById("loaderGeneralAplicacion").className = "loader hidden"
              
            }
          }
    
          if (this.readyState === 4 && this.status !== 200) {      
            initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)          
            document.getElementById("loaderGeneralAplicacion").className = "loader hidden"
          }
        }
        xhttp.send(data);     
    
    }

    function procesarRegla(rule, modo){      

      if(objDatosDashboard !== null){

        if( (Object.keys(objDatosDashboard).length !== 0)){    
          
          if(rule.Rule.isInstaller === "false"){
            rule.Rule.userTelegram = localStorage.getItem("telegramAccount")
          }          

          if(dashboardCommonJS.comprobarPropiedadInstalacion() === false){          
            rule.Rule.ruleOwnerInstallationID = localStorage.getItem("telegramInstallationID")
          }

          rule.Rule.installationName = localStorage.getItem("installationName").split("*")[1]

          params.setObjRuleForm(<RuleForm rule={rule} objDatosDashboard={objDatosDashboard} objDatosDispositivos={objDatosDispositivos} setSelectedRulesOption={params.setSelectedRulesOption} setObjListadoReglas={setObjListadoReglas} guardarRegla={guardarRegla} volverAListadoReglas={volverAListadoReglas} setObjRuleElementSelector={params.setObjRuleElementSelector}/>)               
          document.getElementById("tituloDetalleRegla").innerHTML = modo + " regla"      
          document.getElementById("asideDetalleRegla").className = document.getElementById("asideDetalleRegla").className.replace(" hidden","")                          
        }
        else{
          initialConfigCommonJS.mostrarMensajeInformativo("No se cargaron correctamente los datos del cuadro de mando, que son necesarios para poder crear reglas. Por favor revisa que ves correctamente el cuadro de mando e inténtalo de nuevo. Si el problema continúa repórtanos el problema desde la opción de menú 'Ayuda y soporte'.","info")
        }

      }
      else{
        initialConfigCommonJS.mostrarMensajeInformativo("Vuelve a intentarlo ahora... eres demasiado rápido ;)","info")
      }

    }    

    function volverAListadoReglas(){
      document.getElementById("asideDetalleRegla").className = document.getElementById("asideDetalleRegla").className.replaceAll(" hidden", "") + " hidden"
      cargarReglas("silencioso")
    }

    function guardarRegla(objRegla, modo){

      var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
      var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")        

      //Petición de datos para el paso actual
      var jsonPeticion = { "accountID": localStorage.getItem("accountID"), "installationID": localStorage.getItem("installationId"),"ruleId": objRegla.RULE_ID, "rule": objRegla.Rule }

      if(modo !== "silencioso"){
        document.getElementById("loaderGeneralAplicacion").className = document.getElementById("loaderGeneralAplicacion").className.replace(" hidden","")
      }

      // Guardo la información  
      var xhttp = new XMLHttpRequest();  
        xhttp.open("PUT", putInstallationRules, true);        
        xhttp.setRequestHeader('Content-Type', "application/json");
        xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
        var data = JSON.stringify(jsonPeticion);
        xhttp.onreadystatechange = function() {
          if (this.readyState === 4 && this.status === 200) {
            var jsonRespuesta = JSON.parse(this.responseText)
    
            if(jsonRespuesta.statusCode === "403"){                   
              initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")                            
            }
            else{          
              //Si todo ha ido bien
              if(modo !== "silencioso"){
                document.getElementById("loaderGeneralAplicacion").className = document.getElementById("loaderGeneralAplicacion").className.replaceAll(" hidden", "") + " hidden"
                generalCommonJS.registrarEventoAnalitica(ReactGA, 'REGLAS', 'REGLA - Creada', "", "")
                initialConfigCommonJS.mostrarMensajeInformativo("La regla se ha creado o modificado correctamente.","positive")                 
              }

              try{
                document.getElementById("cambiarEstadoRegla"+objRegla.RULE_ID).removeAttribute("loading")
              }
              catch(error){console.log(error)}                   

              volverAListadoReglas("silencioso")
              
            }

          }
    
          if (this.readyState === 4 && this.status !== 200) {                  
            initialConfigCommonJS.mostrarMensajeInformativo("Ha habido algún problema al eliminar la regla, por favor vuelva a intentarlo.","negative")            
          }

        }
        xhttp.send(data);         

    }

    function cambiarEstadoRegla(objRegla){

      try{
        document.getElementById("cambiarEstadoRegla"+objRegla.RULE_ID).setAttribute("loading", "")
      }
      catch(error){console.log(error)}      

      if(objRegla.Rule.enabled === "true"){objRegla.Rule.enabled = "false"}
      else{objRegla.Rule.enabled = "true"}

      var accionRegla = ""

      if(objRegla.Rule.enabled === "true"){
        accionRegla = "Activada"
      }
      else{
        accionRegla = "Desactivada"
      }

      generalCommonJS.registrarEventoAnalitica(ReactGA, 'REGLAS', 'REGLA - '+accionRegla, "", "")

      guardarRegla(objRegla, "silencioso")

    }

    function mostrarPestaña(pestaña){
      if(pestaña === "Manuales"){
        document.getElementById("pestañaReglasManuales").checked = true
        document.getElementById("pestañaReglasManuales").className = document.getElementById("pestañaReglasManuales").className.replaceAll(" hidden", "")        
        document.getElementById("pestañaReglasInstalador").className = " hidden"
      }
      else{
        document.getElementById("pestañaReglasManuales").className = " hidden"
        document.getElementById("pestañaReglasInstalador").checked = true
        document.getElementById("pestañaReglasInstalador").className = document.getElementById("pestañaReglasInstalador").className.replaceAll(" hidden", "")
      }
    }



      const listManualRules = objListadoReglas.map((rule) =>

        <React.Fragment key={rule.RULE_ID}>
        { (!rule.Rule.name.includes("[AUTO]")) && (rule.Rule.isInstaller === "false") ?
          
              <div id={"regla"+rule.RULE_ID} className="selector icon-wrapper" searchdata={rule.Rule.name.toLowerCase()} >                                                   
                <span id={"spanRegla"+rule.RULE_ID} className="label fill" onClick={() => procesarRegla(rule, "Editar")}>                  
                  <ul className="list ">
                    <li className="list-item">                
                      <div className="content">                      
                        <span className="value">{rule.Rule.name}</span>
                        
                        { rule.Rule.userEmail !== generalCommonJS.obtenerEmailUsuario() ?
                          <span className="label">{rule.Rule.userName}</span>
                          :
                          <></>
                        }

                      </div>
                    </li>
                  </ul>                  
                </span>        
                <ul>                  
                    {rule.Rule.enabled === "true" ? 
                        <li key={"li"+rule.RULE_ID} id={"li"+rule.RULE_ID} className="check multiple toggle devices full-bleed with-divider vertical-center horizontal green" >
                          <input type="checkbox" id={"cambiarEstadoRegla"+rule.RULE_ID} name={"cambiarEstadoRegla"+rule.RULE_ID} onClick={() => cambiarEstadoRegla(rule) } defaultChecked/>
                          <label className="icon-wrapper" htmlFor={"cambiarEstadoRegla"+rule.RULE_ID}></label>
                        </li>
                      : 
                        <li key={"li"+rule.RULE_ID} id={"li"+rule.RULE_ID} className="check multiple toggle devices full-bleed with-divider vertical-center horizontal" >
                          <input type="checkbox" id={"cambiarEstadoRegla"+rule.RULE_ID} name={"cambiarEstadoRegla"+rule.RULE_ID} onClick={() => cambiarEstadoRegla(rule) } />
                          <label className="icon-wrapper" htmlFor={"cambiarEstadoRegla"+rule.RULE_ID}></label>
                        </li>                  
                    }        
                </ul>
              </div>          
        :
          <></>
        }
        </React.Fragment>
        );    

      const listInstallersRules = objListadoReglas.map((rule) =>
      
      <React.Fragment key={rule.RULE_ID}>
      { (!rule.Rule.name.includes("[AUTO]")) && (rule.Rule.isInstaller === "true") ?
        
        <div id={"regla"+rule.RULE_ID} className="selector icon-wrapper" searchdata={rule.Rule.name.toLowerCase()+" "+rule.Rule.userName.toLowerCase()} >
          <span className="label fill" onClick={() => procesarRegla(rule, "Editar")}>
            <ul className="list ">
              <li className="list-item">                
                <div className="content">                  
                  <span className="value">{rule.Rule.name}</span>
                  <span className="label">{rule.Rule.userName}</span>
                </div>
              </li>
            </ul>
        
          </span>        
          <ul>                  
              {rule.Rule.enabled === "true" ? 
                  <li key={"li"+rule.RULE_ID} id={"li"+rule.RULE_ID} className="check multiple toggle devices full-bleed with-divider vertical-center horizontal green" >
                    <input type="checkbox" id={"cambiarEstadoRegla"+rule.RULE_ID} name={"cambiarEstadoRegla"+rule.RULE_ID} onClick={() => cambiarEstadoRegla(rule) } defaultChecked/>
                    <label className="icon-wrapper" htmlFor={"cambiarEstadoRegla"+rule.RULE_ID}></label>
                  </li>
                : 
                  <li key={"li"+rule.RULE_ID} id={"li"+rule.RULE_ID} className="check multiple toggle devices full-bleed with-divider vertical-center horizontal" >
                    <input type="checkbox" id={"cambiarEstadoRegla"+rule.RULE_ID} name={"cambiarEstadoRegla"+rule.RULE_ID} onClick={() => cambiarEstadoRegla(rule) } />
                    <label className="icon-wrapper" htmlFor={"cambiarEstadoRegla"+rule.RULE_ID}></label>
                  </li>                  
              }        
          </ul>
        </div>            
      :
        <></>
      }
      </React.Fragment>
      );

        return (        
          <div id="listadoReglas" className="page">
            <section id="rules" className="step wrapper" style={{justifyContent: "start"}}>
              <div id="botoneraPrincipal" className="content-wrapper" > 

                <div className="horizontal space-between">
                  <h1 id="h1ListadoReglas" className="headline-02">Reglas</h1>              
                  
                  <div className="horizontal gap-02">
                    <button id="botonNuevaRegla" className="button primary size-s" type="button" onClick={ () => dashboardCommonJS.añadirRegla(numeroReglasManuales,procesarRegla, reglaNueva, "Nueva")}><span className="material-icon">add</span>Nueva regla</button>
                  </div>
                </div>


                <fieldset className="radio multiple hidden">
                  <div className="tabs">
                    <input type="radio" name="rules-tabs" id="manual-rules" onClick={() => mostrarPestaña("Manuales")} defaultChecked/>
                    <label className="tab" htmlFor="manual-rules">
                      <span className="label">Manuales <span id="spanNumeroReglasManuales" className="counter">( {numeroReglasManuales} )</span></span>
                    </label>

                    <input type="radio" name="rules-tabs" id="automatic-rules" onClick={() => mostrarPestaña("Automaticas")}/>
                    <label className="tab" htmlFor="automatic-rules">
                      <span className="label">Instaladores <span className="counter">( {numeroReglasInstaladores} )</span></span>
                    </label>

                  </div>
                </fieldset>


                <fieldset id="pestañaReglasManuales">                
                    
                    { numeroReglasManuales > 0 ?
                    <>

                      <fieldset>                        
                        <fieldset className="search automatic">
                          <input type="search" id="searchUserRule" spellCheck="false" autoComplete="off" placeholder="Buscar regla..." onKeyUp={() => rulesCommonJS.filtrarReglasUsuario("Manuales")}/> 
                          <span className="material-icon icon-wrapper" onClick={() => dashboardCommonJS.inicializarCajaBusqueda("searchUserRule","REGLAS_USUARIO","Manuales")}></span>
                        </fieldset>
                      </fieldset>

                      <div id="listadoReglasManuales" className="vertical gap-02" >
                        {listManualRules}
                      </div> 
                    </>                    
                    :
                    <div id="mensajeSinReglasConfiguradas" className="message medium empty">
                      <picture>
                        <source srcSet={imgNoResultsDark} media="(prefers-color-scheme: dark)"/>
                          <img src={imgNoResultsDark} alt=""/>
                      </picture>
                      <h1 className="title">Actualmente no tienes reglas configuradas</h1>
                        <p>Haz click en el botón de arriba para crear la primera</p>
                    </div> 
                    }
                </fieldset>
                
                <fieldset id="pestañaReglasInstalador" className=" hidden">           

                    { numeroReglasInstaladores > 0 ? 
                    <>

                      <fieldset>                        
                        <fieldset className="search automatic">
                          <input type="search" id="searchInstallerRule" spellCheck="false" autoComplete="off" placeholder="Buscar regla..." onKeyUp={() => rulesCommonJS.filtrarReglasUsuario("Instaladores")}/> 
                          <span className="material-icon icon-wrapper" onClick={() => dashboardCommonJS.inicializarCajaBusqueda("searchInstallerRule","REGLAS_USUARIO","Instaladores")}></span>
                        </fieldset>
                      </fieldset>

                      <div id="listadoReglasAutomaticas" className="vertical gap-02" >
                        {listInstallersRules}
                      </div>

                    </>                    
                    :
                    <div id="mensajeSinReglasConfiguradas" className="message medium empty">
                      <picture>
                        <source srcSet={imgNoResultsDark} media="(prefers-color-scheme: dark)"/>
                          <img src={imgNoResultsDark} alt=""/>
                      </picture>
                      <h1 className="title">Actualmente no tienes reglas de instaladores configuradas</h1>                        
                    </div>
                    }
                </fieldset>
                
              </div>
            </section>
          
          </div>        
        )

}

export default RulesList